export default __webpack_public_path__ + "static/media/location.ef318001.svg";